import React, {Component} from 'react'
import { Link } from 'react-router-dom'
import * as firebase from 'firebase/app'
import {notify} from 'react-notify-toast'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import 'react-datepicker/dist/react-datepicker.css'
import DatePicker from 'react-datepicker'
import Select from 'react-select'
import moment from 'moment'

// TODO: if admin/master, choose user first

class Tasks extends Component {

  constructor() {
    super()

    this.state = {
      note: '',
      tasks: [],
      targetDate: null,
      user: null,
      selectedUser: null,
      showForm: false
    }

    this.handleChangeNote     = this.handleChangeNote.bind(this)
    this.addTask              = this.addTask.bind(this)
    this.handleChangeDatePicker     = this.handleChangeDatePicker.bind(this)
    this.handleChangeUserSelect     = this.handleChangeUserSelect.bind(this)
    this.handleChangeDatePicker     = this.handleChangeDatePicker.bind(this)
    this.showForm                   = this.showForm.bind(this)
    this.backToTasks                = this.backToTasks.bind(this)
  }

  render() {

    if ( this.state.user===null ) {
      return (
        <div className="container waitDiv">
          <div ref="waitAnimDiv" className="waitAnim"> </div>
        </div>
      )
    }

    // if user has no name in database, force to fill
    if ( this.state.user.name===undefined || this.state.user.name.trim()==='' ) {

      return (
        <div>
          <br/>
          Por favor, indica tu nombre en la sección de Configuración
          <br/>
          <Link to="/setup" style={{ fontWeight: 'bold', textDecoration: 'none', color: '#000000' }}>
            <button className='btn btn-lignht btn-sm' onClick={this.cancelEdit}>Ir a Configuración</button>
          </Link>
        </div>
      )
    }

    // load users list for combo
    let usersList = []
    this.state.users.map( user => {

      let name = user.email
      if ( user.name!==undefined ) {
        name = user.name
      }

      usersList.push({
        value: user.email,
        label: name
      })
      return true
    })

    return (
      <div className="module">
        <div className="container moduleHeaderDiv">
            <div className="row rowDiv"><h2>Tareas</h2></div>
        </div>
      
        { this.state.user.role!=='user'? 
          <div className="pickUserDiv centered">
              <label className="col-form-label formLabel">Selecciona Paciente</label>
<br/>
<br/>
              <Select className="reactSelect"
                value={this.state.selectedUser}
                onChange={this.handleChangeUserSelect}
                options={usersList}
                isSearchable="true"
                isClearable="true"
                />
            
          </div>
          : null
        }

        <div className="row">

          { !this.state.showForm ?
            <div className="col-md-6 centered">
              <button className='btn btn-lignht btn-sm' onClick={this.showForm}>Nueva Tarea</button>
              <br/>
              Lista de Tareas
              <br/>
              <br/>
              <div className="dailyDiv">
                {
                  this.state.tasks.map( note => {
                    const user = this.state.usersMap.get(note.user)
                    let userName = user.email
                    if (user.name!==undefined){
                      userName = user.name
                    }
                    let state = 'check_box_outline_blank'
                    let doneStyle = ''
                    if ( note.done===true ) {
                      state = 'check_box'
                      doneStyle = 'tachado'
                    }
                    return (
                      <div className="noteDiv" key={note.key}>
                        <i className="material-icons btnIconSmall" title="" onClick={()=>this.toogleState(note.key, note.done)}>{state}</i>
                        <span className="taskTitle">{note.targetDate}</span>
                        <br/>
                        <span className={doneStyle}>
                          {note.note}
                        </span>
                        <br/>
                        <span className="taskInfo">
                          <i className="material-icons btnIconSmall" title="Eliminar" onClick={()=>this.removeTask(note.key)}>delete</i>
                          &nbsp;&nbsp;
                          Creada {note.date} por {userName}
                        </span>
                        <br/>
                        <hr/>
                      </div>
                    )
                  })
                }
              </div>
            </div>
            : null 
          }
          { this.state.showForm ?
          <div className="col-md-6 schedulerForm centered">
            Crear Nueva Tarea

            <div className="container">

                <div className="formDiv">
                  <label className="col-form-label formLabel">Selecciona fecha/hora</label>
                  
                  <DatePicker
                    selected={this.state.targetDate}
                    onChange={this.handleChangeDatePicker}
                    locale="es"
                    dateFormat="DD/MM/YYYY"
                    className="form-control dateInput"
                    />
                </div>

                <div className="formDiv">
                  <label className="col-form-label formLabel">Descripción de Tarea</label>

                  <textarea className="form-control dailyTextarea" id="note" ref="note" name="note" rows="6"
                        maxLength="512"
                        value={this.state.note}
                        onChange={this.handleChangeNote}></textarea>

                </div>

                <div className="formDiv">
                    <button className='btn btn-lignht btn-sm floatRight' onClick={this.addTask}>Guardar</button>
                    <button className='btn btn-lignht btn-sm floatRight' onClick={this.backToTasks}>Cancelar</button>
                </div>            

              </div>
            </div>
          
          : null 
          }
      </div>
      </div>
    )
  }

  componentDidMount () {
    // load users
    firebase.database().ref("users").on ( 'value', users => {
      let usersMap = new Map()
      let userObj = null
      let usersList = []
      users.forEach ( user => {
        let u = user.val()
        u.key = user.key
        usersMap.set( u.email, u )
        usersList.push(u)
        if ( u.email===firebase.auth().currentUser.email){
          userObj = u
        }
      })
      this.setState({
        usersMap: usersMap,
        user: userObj,
        users: usersList,
        selectedUser: {
          value: userObj.email,
          label: userObj.name
        }
      })

      this.loadUserTasks ( firebase.auth().currentUser.email )
    })    
  }

  loadUserTasks ( userEmail ) {
    console.log('userEmail: ' + userEmail )
    // load user tasks
    firebase.database().ref("tasks").orderByChild("user").equalTo(userEmail).on ( 'value', snap => {
      let tasks = []

      snap.forEach ( note => {
        let n = note.val()
        n.key = note.key
        tasks.push( n )
      })
      
      this.setState({
        tasks: tasks.reverse()
      })
    })
  }

  handleChangeNote () {
    this.setState({
      note: this.refs.note.value
    })
  }

  addTask() {

    // validate date
    if ( this.state.targetDate===null ) {      
      notify.show ('Indica fecha/hora', 'error', 1250);
      return false
    }
    if ( this.state.note.trim()==='' ){
      notify.show ('Introduce texto', 'error', 1250);
      return false
    }

    firebase.database().ref("tasks").push({
      user: this.state.selectedUser.value,
      date: new moment().format('DD/MM/YYYY HH:mm'),
      targetDate: this.state.targetDate.format('DD/MM/YYYY'),
      note: this.state.note.trim(),
      done: false
    }).then ( span => {      
      this.setState({
        targetDate: null,
        userKey: null,
        selectedEvent: null,
        note: '',
        showForm: false
      })
      notify.show ('Nueva tarea guardada', 'success', 1250)
    })
    .catch( error => {
      notify.show ('Error guardando tarea: ' + error, 'error', 1250)
    })

  }

  removeTask (taskkey) {
    firebase.database().ref("tasks").child(taskkey).remove().then(span => {
      notify.show ('Tarea eliminada', 'success', 1250)
    })
  }

  toogleState (taskkey, done) {
    firebase.database().ref("tasks").child(taskkey).child("done").set(!done).then(span => {
      notify.show ('Tarea modificada', 'success', 1250)
    })
  }
  
  handleChangeDatePicker (value) {
    this.setState({
      targetDate: value
    })
  }

  handleChangeUserSelect (user) {
    this.setState({ 
      selectedUser: user
    })
    this.loadUserTasks ( user.value )
  }

  showForm() {
    this.setState({
      showForm: true
    })
  }

  backToTasks () {
    this.setState({
      showForm: false
    })
  }

}

export default Tasks
